/* GTJ: scroll + page-detection classes so the theme never depends on modern
   CSS selectors (:has) or browser-specific sticky behavior.
   - html.gtj-scrolled     -> page is scrolled past the top (>50px)
   - html.gtj-on-image     -> the nav currently sits fully on a
                              banner-type image section (hero slideshow,
                              image banner, campaign banner - NOT product
                              media); Scuffers header renders transparent
                              while set, solid otherwise, both directions
   - html.gtj-pdp          -> a stacked product page is present
   - html.gtj-hero-first   -> first section of main is a hero slideshow
   - html.gtj-menu-lock    -> mobile menu drawer is open (real scroll lock)
   - .gtj-pdp-page-width   -> added to the product page-width container
   - .gtj-pdp-section      -> added to the product shopify-section wrapper */
(function () {
  var last = null;
  var lastOnImg = null;
  var imgRanges = [];
  /* BANNER-TYPE image sections only (user 31Jul): hero slideshow, Dawn
     image banners, GTJ campaign banners. NOT product media, NOT
     image-with-text. The nav goes transparent whenever it sits fully
     on one of these, in BOTH scroll directions. */
  function measureBanners() {
    imgRanges = [];
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var secs = document.querySelectorAll('#MainContent .shopify-section');
    for (var i = 0; i < secs.length; i++) {
      var hit = secs[i].querySelector('slideshow-component, .banner, .gtj-campaign-banner');
      if (!hit) continue;
      /* the shopify-section wrapper can measure 0-height (its content
         does the sizing) - fall back to the banner element itself */
      var el = secs[i].getBoundingClientRect().height > 120 ? secs[i] : hit;
      var r = el.getBoundingClientRect();
      if (r.height < 120) continue;
      imgRanges.push([r.top + y, r.bottom + y]);
    }
    /* product pages (31Jul): the FIRST gallery image counts too - the
       card is transparent over it (black flavor, see CSS) and flips
       solid once it's crossed, same mechanic as the homepage hero */
    var pm = document.querySelector('.product__media-wrapper .product__media-item');
    if (pm) {
      var pr = pm.getBoundingClientRect();
      if (pr.height > 120) imgRanges.push([pr.top + y, pr.bottom + y]);
    }
    /* r50 (user: the UPPER of two stacked banners still hitches on
       iPhone): between back-to-back banner sections there is a thin
       seam where the nav is fully on NEITHER - on-image flipped
       off-then-on within ~100px of scroll = two full-document restyles
       mid-flick. Merge ranges whose gap is smaller than a nav band
       (160px): stacked banners read as ONE zone, zero flips between
       them. */
    imgRanges.sort(function (a, b) { return a[0] - b[0]; });
    var merged = [];
    for (var m = 0; m < imgRanges.length; m++) {
      var cur = imgRanges[m];
      if (merged.length && cur[0] - merged[merged.length - 1][1] < 160) {
        if (cur[1] > merged[merged.length - 1][1]) merged[merged.length - 1][1] = cur[1];
      } else {
        merged.push([cur[0], cur[1]]);
      }
    }
    imgRanges = merged;
  }
  var lastMeasure = 0;
  function evaluate(force) {
    /* ROUND 45: the whole evaluation FREEZES while a drawer/search
       open-close window is in flight - round-44's continuous re-measure
       ran against TRANSIENT teardown layout (fixed header, lock-pad,
       scroll pin) and flapped on-image mid-close: black-then-white over
       banners on menu close, bar stutter on a scrolled search close.
       The close choreographies call gtjRemeasure() once settled, which
       forces one clean evaluation. */
    if (!force && (window.gtjFreezeOnImg ||
        document.documentElement.classList.contains('gtj-menu-lock') ||
        document.documentElement.classList.contains('gtj-md-restore'))) return;
    /* ROUND 44: banner ranges are re-measured DURING scroll - any layout
       shift after the load-time measurement (accordions, view-more
       pagination, app banners, modal teardown) left stale ranges.
       r48: throttle raised 400ms -> 1600ms - re-walking every section
       with getBoundingClientRect mid-scroll was a repeated forced
       layout that read as stutter on phones; post-load layout shifts
       are rare enough that 1.6s staleness is invisible. */
    var t = +new Date();
    if (t - lastMeasure > 1600) { lastMeasure = t; measureBanners(); }
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var away = y > 50;
    if (away !== last) {
      last = away;
      document.documentElement.classList.toggle('gtj-scrolled', away);
    }
    /* transparent while an image fully covers the NAV ROW's band:
       image top above the nav's top edge, image bottom below its
       bottom edge. Measured against the nav's real rect - NOT the
       viewport top - because the ticker row sits above it (the PDP
       first image tucks under the nav but not under the ticker; over
       white page areas the transparent card reads identical to solid,
       so nav-row coverage is the right trigger). */
    /* 5Aug pre-paint hint guard: header-drawer paints the homepage's
       on-image state before load. Until the hero has real layout the
       ranges can come back EMPTY for a beat - an empty measurement near
       the top must never strip the hint (it re-flashed the solid bar). */
    if (!imgRanges.length && y < 200 &&
        document.documentElement.classList.contains('gtj-hero-first')) return;
    var hdr = document.querySelector('.section-header .header');
    var hr = hdr ? hdr.getBoundingClientRect() : null;
    var navTop = y + (hr ? hr.top : 42);
    var navBottom = y + (hr ? hr.bottom : 102);
    var onImg = false;
    for (var i = 0; i < imgRanges.length; i++) {
      if (imgRanges[i][0] <= navTop + 2 && imgRanges[i][1] >= navBottom) { onImg = true; break; }
    }
    if (onImg !== lastOnImg) {
      lastOnImg = onImg;
      document.documentElement.classList.toggle('gtj-on-image', onImg);
    }
  }
  /* r48 (user: banner-section scroll stutter on iPhone): scroll events
     arrive in DENSE BURSTS during momentum scrolling - running the
     evaluation (querySelector + getBoundingClientRect = forced layout)
     on every event was repeated sync layout work between frames. Gate
     it to at most ONCE PER PAINTED FRAME; forced calls (gtjRemeasure)
     stay synchronous. */
  var gtjTicking = false;
  function onScr(force) {
    if (force === true) { evaluate(true); return; }
    if (gtjTicking) return;
    gtjTicking = true;
    requestAnimationFrame(function () {
      gtjTicking = false;
      evaluate(false);
    });
  }
  window.addEventListener('scroll', onScr, { passive: true });
  window.addEventListener('resize', function () { measureBanners(); onScr(); }, { passive: true });
  window.addEventListener('load', function () { measureBanners(); onScr(); });
  /* image loads shift layout after first paint - re-measure a few times */
  setTimeout(function () { measureBanners(); onScr(); }, 1500);
  setTimeout(function () { measureBanners(); onScr(); }, 4000);
  /* round 44/45: on-demand re-measure hook for modal/drawer teardowns -
     forces one clean evaluation straight through the round-45 freeze */
  window.gtjRemeasure = function () {
    measureBanners();
    lastMeasure = +new Date();
    onScr(true);
  };
  onScr();

  /* Dawn "locks" page scroll while the menu drawer is open by putting
     overflow:hidden on BODY only - mobile browsers (iOS Safari especially)
     keep scrolling the root element regardless. Mirror Dawn's lock class
     onto <html> so the page truly freezes and only the drawer scrolls. */
  function syncMenuLock() {
    var locked =
      document.body.classList.contains('overflow-hidden-mobile') ||
      document.body.classList.contains('overflow-hidden-tablet');
    document.documentElement.classList.toggle('gtj-menu-lock', locked);
  }
  function watchMenuLock() {
    syncMenuLock();
    var mo = new MutationObserver(syncMenuLock);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.body) watchMenuLock();
  else document.addEventListener('DOMContentLoaded', watchMenuLock);

  function detect() {
    var stacked = document.querySelector('.product--stacked');
    if (stacked) {
      document.documentElement.classList.add('gtj-pdp');
      var sec = stacked.closest('.shopify-section');
      if (sec) sec.classList.add('gtj-pdp-section');
    }
    var mw = document.querySelector('.product__media-wrapper');
    if (mw) {
      var pw = mw.closest('.page-width');
      if (pw) pw.classList.add('gtj-pdp-page-width');
    }
    var main = document.getElementById('MainContent');
    if (main && main.firstElementChild && main.firstElementChild.querySelector('slideshow-component')) {
      document.documentElement.classList.add('gtj-hero-first');
    }
    measureBanners();
    onScr();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detect);
  } else {
    detect();
  }
})();
